import { NgbModalRef } from '@cmps/ng-bootstrap';

import { PopUpComponent } from './experimental.pop-up';
import { SearchUserContainerComponent } from './search-user.container.component';
import { User } from './user.model';

export class SearchUserDialogRef {
    /** @internal */ _refNgb: NgbModalRef;
    /** @internal */ _refPopUp: PopUpComponent<SearchUserContainerComponent>;

    close(user?: User): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._refNgb && this._refNgb.close(user);
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._refPopUp && this._refPopUp.close(user);
    }
}
